module.exports = __webpack_public_path__ + "img/line.3811a9e9.svg";